import { cn } from '@/src/helpers';
import { Flex } from '../../flex';
import { pageClasses } from '../page.constants';
import { FC, HTMLAttributes } from 'react';

type PageHeaderProps = HTMLAttributes<HTMLHeadingElement>;

/**
 * Child component for Page that renders a title, as well as optional action and children.
 * @param {Object} props Component props
 * @param {boolean} [props.borderless] Optional boolean to hide the bottom border. Useful for pages that have tab navigation below the title.
 * @returns PageHeader content
 */
export const PageHeader: FC<PageHeaderProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Flex
      as="header"
      wrap="wrap"
      align="center"
      justify="between"
      className={cn(
        pageClasses.header,
        'mx-5 mb-4 mt-5 gap-x-2 gap-y-5',
        className
      )}
      {...rest}
    >
      {children}
    </Flex>
  );
};
